import { useLang } from '@/i18n';
import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import styles from './index.module.scss';
export default function Comp() {
    const { t } = useLang('Delta3MaxSeriesStation.BannerA');
    const dataA: EcoBannerProps = {
        layout: 'center-left',
        className: styles.comp,
        pc: 'https://websiteoss.ecoflow.com/upload/image/1762222899021/style1_desktop_center2.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1762222898875/kv-m.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1762222898875/kv-m.jpg',
        label: t('label'),
        labelColor: '#ffffff',
        title: t('title'),
        desc: t('desc'),
        rBtnIsYouToBe: true,
        lHref: '#ProductComparison',
        lChildren: t('btnL'),
        lDataLayer: {
            event: 'uaEvent',
            event_name: 'click_anchor',
            position: '#ProductComparison',
            button_name: t('btnL'),
            __btn_id1: 'BannerA .__btn_l',
            __btn_id2: 'bannerBtnL',
            __btn_type: 'common',
        },
        rDataLayer: {
            event: 'uaEvent',
            event_name: 'video',
            title_name: t('btnR'),
            position: 'https://www.youtube.com/embed/0lRjtGgSvCo?si=lWrCvf76sC64ujPX',
            __btn_id1: 'BannerA .__btn_r',
            __btn_id2: 'bannerBtnR',
            __btn_type: 'common',
        },

        theme: 'white',
        rType: 'outlined',
        rHref: 'https://www.youtube.com/embed/0lRjtGgSvCo?si=lWrCvf76sC64ujPX',
        rChildren: t('btnR'),
    };
    return (
        <section className={`${styles.banner} GtmModuleData-section BannerA`} data-section-id={'BannerA'}>
            <EcoBanner {...dataA} />
            <img
                className="banner-disaster"
                src="https://websiteoss.ecoflow.com/figma-uploads/1760963490810-y50m6k-compressed-%E9%98%B2%E7%81%BElogo.png"
                alt=""
            />
        </section>
    );
}
